import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }

  pushAnalyticsEvent(eventName, data = {}) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName, ...data })
  }

  isOnScreen(elem) {
    const element = typeof elem === 'string' ? document.querySelector(elem) : elem
    if (!element) return false

    const windowHeight = window.innerHeight
    const scrollY = window.scrollY
    const rect = element.getBoundingClientRect()
    const top = rect.top + scrollY
    const height = rect.height
    const bottom = top + height

    return (top >= scrollY && top < scrollY + windowHeight) ||
           (bottom > scrollY && bottom <= scrollY + windowHeight) ||
           (height > windowHeight && top <= scrollY && bottom >= scrollY + windowHeight)
  }
}
